import Grid from '@material-ui/core/Grid'
import EurestoForm from 'Components/Form'
import Input from "Components/Input"
import Modal from "Components/Modal"
import Select from 'Components/Select'
import Title from "Components/Title"
import ApiRequest from 'EurestoApi/ApiRequest'
import User from 'EurestoClass/User'
import EurestoDiv from "EurestoComponents/EurestoDiv"
import Upload from 'EurestoComponents/Upload/DefaultUpload'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React from 'react'
import RechercheProduit from "../../../../../App/Module/Gestion/Component/Table/Produit"
import AjoutProduit from "../../../../../App/Module/Gestion/Page/Ajout"
import DataComponent from '../../../DataComponents/index'



const project = require('EurestoConfig/project.config')

export default class extends React.Component {
    constructor (props) {
        super(props)

        const newState = {
            module: 'fiche_technique',
            type: 'create',
            ...props,
            action: props.action,
            key: Utils.getRandomNumber(),
            showModalProduit: false,
            addNewProduit: false,
        }
        this.state = {
            saveState: { ...EurestoClone(newState)},
            ...newState
        }
    }

    componentDidMount () {
        if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
            this.getFormation()
        }
    }

    getFormation = async () => {
        const result = await ApiRequest(project.api + 'pedagogie', {
            requete: 'exercice',
            action: 'get',
            id: this.state.id
        }, { showAlertError: false })
        if(result && result.code === 1) {
            const newState = {
                defaultLibelle: result.results.libelle,
                libelle: result.results.libelle,
                commentaire: result.results.commentaire,
                formations: result.results.formations,
                produit_id: result.results.produit_id,
                produit_libelle: result.results.produit_libelle,
                type: result.results.type,
                module: result.results.module,
                medias: result.results.medias,
                key: Utils.getRandomNumber()
            }
            this.setState({
                saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
                ...newState,
                key: Utils.getRandomNumber()
            }, this.forceUpdate)
        }
    }

    onChangeState = (e, name) => {
        this.setState({
            [name]: e
        }, this.forceUpdate)
    }

    onCancel = _ => {
        this.setState({
            libelle: undefined,
            commentaire: undefined,
            module: 'fiche_technique',
            type: 'create',
            action: 'add',
            produit_id: undefined,
            produit_libelle: '',
            formations: [],
            medias: [],
            key: Utils.getRandomNumber()
        }, () => this.props.onCancel())
    }

    onSave = async (action) => {
        const result = await ApiRequest(project.api + 'pedagogie', {
            requete: 'exercice',
            action: action === 'update' ? 'update' : 'add',
            id: this.state.id,
            libelle: this.state.libelle,
            module: this.state.module || 'fiche_technique',
            type: this.state.type || 'create',
            produit_id: this.state.produit_id,
            commentaire: this.state.commentaire,
            formations: this.state.formations,
            medias: this.state.medias,
        })
        if (result.code === 1) {
            this.onCancel()
        }
    }

    onDelete = async () => {
        const r = await ApiRequest(project.api + 'pedagogie', {
            requete: 'formation',
            action: 'delete',
            id: this.state.id,
        })
        if (r && r.code === 1) {
            this.setState({
                action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
            })
        }
    }

    onArchive = async () => {
        console.log('not done yet')
    }

    onView = (action) => {
        const newState = this.state.saveState
        newState.saveState = {...EurestoClone(this.state.saveState)}
        newState.key = Utils.getRandomNumber();
        const keys = Object.keys(this.state)
        const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
        this.setState({
            ...stateReset,
            ...newState
        }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
    }

    onAddMedia = () => {
        const medias = this.state.medias || []
        medias.push({
            media_libelle: ''
        })
        this.setState({
            medias: medias
        }, this.forceUpdate)
    }

    onChangeMedia = (i) => (data, name) => {
        const {medias} = this.state
        const media = medias[i]

        media[name] = data
        medias[i] = media
        this.setState({
            medias: medias
        }, this.forceUpdate)

    }

    onDeleteMedia = (i) => {
        const {medias} = this.state
        medias.splice(i, 1)
        this.setState({
            medias: medias
        }, this.forceUpdate)
    }

    catchedUploadFile = (i) => (file, base64) => {
        const {medias} = this.state
        const media = medias[i]

        media.media_base64 = base64
        media.media_lien = `data:${file.type};base64,`+ base64
        media.media_type = file.type
        media.media_extension = file.name.split('.').slice(-1)[0]
        medias[i] = media
        this.setState({
            medias: medias
        }, this.forceUpdate)
    }

    form = (disabled, autoFocus) => {
        console.log('###############', this.state.produit_libelle)
        return (
            <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
                  justify="flex-start"
                  alignItems="stretch">
                <Input
                    inline
                    key={autoFocus}
                    autoFocus={autoFocus}
                    title={EurestoI18n.t('commun:Nom')}
                    onChange={this.onChangeState}
                    name={'libelle'}
                    disabled={disabled}
                    value={this.state.libelle}
                />
                <Select
                    inline
                    title={EurestoI18n.t('commun:Module')}
                    disabled={true}
                    onChange={this.onChangeState}
                    name="module"
                    options={[{
                        label: EurestoI18n.t('pedagogie:Fiche Technique'),
                        value: 'fiche_technique'
                    }]}
                    value={'fiche_technique'}/>
                <Select
                    inline
                    title={EurestoI18n.t('commun:Type')}
                    disabled={disabled}
                    onChange={this.onChangeState}
                    name="type"
                    options={[{
                        label: EurestoI18n.t('pedagogie:À compléter'),
                        value: 'complete'
                    },{
                        label: EurestoI18n.t('pedagogie:À créer'),
                        value: 'create'
                    }]}
                    value={this.state.type || 'create'}/>
                {this.state.type === 'complete' &&  <Input
                    inline
                    key={Utils.uuidv4()}
                    id={'produit-exercice-'+this.state.key}
                    name="produit_libelle"
                    disabled={true}
                    onClick={() => this.closeModal(true)}
                    type="text"
                    value={this.state.produit_libelle}
                    title={EurestoI18n.t('commun:Produit')}
                />}
                <DataComponent
                    inline
                title={EurestoI18n.t('commun:Formations')}
                name="formation"
                disabled={disabled}
                type={Constants.typeSaisie.ComboMulti}
                onChange={this.onChangeState}
                data={this.state.formations}
                object={Constants.donnee.formation}
                module={Constants.module.PEDAGOGIE}/>
                <Input
                    inline
                    title={EurestoI18n.t('commun:Consigne')}
                    onChange={this.onChangeState}
                    name={'commentaire'}
                    multi
                    rows={10}
                    rowsMax={20}
                    disabled={disabled}
                    value={this.state.commentaire}
                />
                <Title
                       style={{padding: '5px 0'}} title={'Documents Annexes'}
                       buttons={!disabled &&
                       <button type="button" onClick={this.onAddMedia}
                               disabled={disabled}
                               className="text-success ei-commun_ajouter"
                               style={{display: 'inline-block', margin: '0px 5px'}}/>}>

                    {
                        (this.state.medias || []).map((data, index) => (
                            <Grid key={index} container style={{margin: 0, padding: 0}} spacing={0} justify={'center'}
                                  alignItems={'center'}>
                                <Grid item style={{margin: 0, padding: 0}}>
                                    <Upload style={{height: 31, maxHeight: 31, width: 31, overflow: 'hidden', margin: '2.5px 5px 2.5px 2.5px', borderRadius: '50%'}}
                                            disabled={disabled}
                                            catchedUploadFile={this.catchedUploadFile(index)}>
                                        {data.media_type && data.media_type.indexOf('image/') === -1 ? <i className={'ei-module_documentation fa-2x'}/> : <img style={{borderRadius: '50%'}} width={30} height={30}
                                             src={data.media_lien} alt={data.media_libelle}/>}
                                    </Upload>
                                </Grid>
                                <Grid item xs style={{margin: 0, padding: 0}}>
                                    <Input
                                        title={EurestoI18n.t('commun:Nom')}
                                        onChange={this.onChangeMedia(index)}
                                        name={'media_libelle'}
                                        disabled={disabled}
                                        value={data.media_libelle}
                                    />
                                </Grid>
                                <Grid item>
                                    <button type="button" onClick={() => this.onDeleteMedia(index)}
                                            className="text-danger ei-commun_enlever"
                                            disabled={disabled}/>
                                </Grid>
                            </Grid>
                        ))
                    }
                </Title>
            </Grid>
        )
    }

    closeModal = (open = false) => {
        this.setState({
            showModalProduit: open,
            addNewProduit: false
        }, this.forceUpdate)
    }

    handleSelectedProduct = (row) => {
        console.log(row, document.getElementById('produit-exercice-'+this.state.key))
        document.getElementById('produit-exercice-'+this.state.key).value = row.libelle
        this.setState({
            produit_id: row.id,
            produit_libelle: row.libelle,
            showModalProduit: false,
            addNewProduit: false
        }, this.forceUpdate)
    }

    handleAddProduit = _ => {
        this.setState({
            addNewProduit: true
        }, this.forceUpdate)
    }

    render () {
        return (
            <React.Fragment>
                <EurestoForm key={this.state.key}
                         {...this.props.formProps}
                         libelle={this.state.defaultLibelle}
                         action={this.state.action}
                         isAllow={this.props.isAllow}
                         onSave={this.onSave}
                         onCancel={this.onCancel}
                         onDelete={this.onDelete}
                         onArchive={this.onArchive}
                         onView={this.onView}
                         libelleAdd={EurestoI18n.t('commun:Nouvel exercice')}
                         children={this.form}/>
                         <Modal open={this.state.showModalProduit} onClose={this.closeModal} grid={{ xs: 10 }}>
                        <EurestoDiv
                            fromModal={true} title={'Sélection/Ajout Fiche technique'} buttonsLeft={!this.state.addNewProduit && [
                            {
                                title: 'Ajouter',
                                icon: ' ei-commun_ajouter',
                                cb: this.handleAddProduit
                            }
                        ]} buttonsRight={[{
                            icon: ' ei-commun_fermer',
                            className: 'EurestoError--text EurestoText',
                            cb: this.closeModal
                        }
                        ]} style={{
                            margin: 0,
                            padding: 0,
                            maxHeight: User.CalculHeight.getHeightWanted(15),
                            height: User.CalculHeight.getHeightWanted(15),
                            overflowY: 'auto'
                        }}>
                            {!this.state.addNewProduit &&
                            <RechercheProduit onClick={this.handleSelectedProduct} defaultSearch={{ type_produit_id: [2,5] }} type="produit" view={'list'}
                                              name={Utils.uuidv4()}
                                              showSearch={true}/> ||
                            <AjoutProduit modalHeight={50} handleAdd={this.handleSelectedProduct} handleCancel={this.closeModal}/>}
                        </EurestoDiv>
            </Modal>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Pedagogie/Exercice.js